exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "textarea[data-v-303b9566]{display:block;width:100%;padding:.375rem .75rem;font-size:1rem;font-weight:400;line-height:1.6;color:#495057;background-color:#fff;background-clip:padding-box;border:1px solid #ced4da;border-radius:.25rem;transition:border-color .15s ease-in-out,box-shadow .15s ease-in-out}textarea[data-v-303b9566]:focus{border:none;outline:none;box-shadow:0 0 5px 0 #2564f5}textarea[data-v-303b9566]:disabled{cursor:not-allowed;background-color:#eee}", ""]);

// exports
